<template>
  <div
    :id="photo.file.id"
    :class="['card__wrapper', selected.length ? 'active' : '']"
  >
    <div class="image__container">
      <img
        class="image"
        :src="photo.file.fullPath"
      >
    </div>
    <b-button-close
      v-if="showDelete"
      class="close-button"
      @click="$emit('deletePhoto', photo)"
    />
    <b-form-checkbox
      v-if="showPreviewToggle"
      v-model="photo.is_preview"
      name="checkbox-1"
      class="preview_checkbox"
      @click.native="changeIsPreviewStatus(!photo.is_preview)"
    >
      Превью
    </b-form-checkbox>
    <div class="tags__wrapper">
      <div
        v-for="(tag, index) in (photo.tags || [])"
        :key="`${tag.type || 'custom'}-${tag.name}-${index}`"
        :class="['tag', tag.type === 'bib' ? 'tag--bib' : 'tag--custom']"
      >
        <span>
          {{ formatTagLabel(tag) }}
        </span>
        <b-button-close
          class="close"
          @click="deleteTag(tag)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { BButtonClose, BFormCheckbox } from 'bootstrap-vue'
import crudModule from '../../../libs/crud_module'

const photoTagsModule = crudModule({
  entity_name: 'albums-tags/photo',
})

const photoModule = crudModule({
  entity_name: 'album/photo',
})

export default {
  components: {
    BFormCheckbox,
    BButtonClose,
  },
  directives: {
    Ripple,
  },
  props: {
    photo: {
      type: Object,
      required: true,
    },
    album: {
      type: Object,
      default: () => ({}),
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showPreviewToggle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      checkedPhoto: [],
      checkedPhotos: [],
      selected: [],
      modalShow: false,
    }
  },
  methods: {
    formatTagLabel(tag) {
      if (tag.type === 'bib') {
        return `#${tag.name}`
      }
      return tag.name
    },
    async changeIsPreviewStatus(isPreviewStatus) {
      if (!this.photo.id) {
        this.photo.is_preview = isPreviewStatus
        return
      }

      const payload = {
        file_id: this.photo.file_id || this.photo.file?.id,
        is_preview: isPreviewStatus,
      }

      await photoModule
        .updateItem(this.photo.id, payload)
        .then(response => {
          this.isloading = false
          return response
        })
        .catch(() => {
          this.isloading = false
          this.photo.is_preview = !isPreviewStatus
        })
    },

    async deleteTag(tag) {
      if (!this.photo.id) {
        if (this.photo.tags) {
          this.photo.tags = this.photo.tags.filter(
            item => !(item.name === tag.name && item.type === tag.type),
          )
        }
        return
      }

      const payload = {
        name: tag.name,
        type: tag.type || 'custom',
        start_id: tag.start_id || this.album.start_id || this.album.start?.id,
      }

      await photoTagsModule
        .updateItem(this.photo.id, payload)
        .then(response => {
          this.isloading = false
          if (this.photo.tags) {
            this.photo.tags = this.photo.tags.filter(
              item => !(item.name === tag.name && item.type === tag.type),
            )
          }
          return response
        })
        .catch(() => {
          this.isloading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.card__wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  border: 1px solid #c3c2c7;
  padding: 15px 0 5px;
  border-radius: 5px;
  min-height: 230px;
  box-shadow: 0 2px 4px 0 #c3c2c7;
  cursor: pointer;

  .image__container {
    padding: 0 10px 5px;

    .image {
      width: 100%;
      height: 145px;
      border-radius: 5px;
      object-fit: cover;
    }
  }

  .close-button {
    position: absolute;
    top: -5px;
    right: 1px;
  }

  .tags__wrapper {
    align-self: center;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 5px;
    padding: 0 10px;
    gap: 4px;

    .tag {
      display: flex;
      align-items: center;
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 12px;

      .close {
        margin-left: 3px;
      }
    }

    .tag--bib {
      background: #eafaf1;
      color: #1e7e34;
    }

    .tag--custom {
      background: #eef0ff;
      color: #5e50ee;
    }
  }

  .preview_checkbox {
    align-self: flex-start;
    margin-left: 10px;
  }
}

.active {
  border-color: #5e50ee;
  box-shadow: 0 2px 4px #5e50ee;
}
</style>
